module.exports = __webpack_public_path__ + "static/media/bg-1.8805e5de.png";